import React, {} from "react";
import { Dialog, DialogTitle, DialogContent, 
  DialogContentText, DialogActions, Button} from "@mui/material";


//Takes the DialogContentText as children
export const ConfirmDialog = (props) => {
  const {open, handleClose, titleText, 
    handleCancel, handleConfirm, confirmText} = props;


  return (
  <Dialog
    open={open}
    onClose={handleClose}
  >
    <DialogTitle>
      {titleText}
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        {props.children}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCancel} autoFocus>Cancel</Button>
      <Button onClick={handleConfirm} color="warning">{confirmText ? confirmText : "Continue"}</Button>
    </DialogActions>


  </Dialog>
  )
}